var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "below-menu" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/loading.gif" } }),
          _c("div", { staticClass: "loading" }, [
            _vm._v(" " + _vm._s(_vm.loadingMsg) + " ")
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "row fixed-top page-header" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-outline-primary btn-xs float-right header-btn",
            on: { click: _vm.newQuestion }
          },
          [_vm._v(" Add New Question ")]
        ),
        _c(
          "button",
          {
            staticClass:
              "btn btn-outline-primary btn-xs float-right header-btn",
            staticStyle: { "margin-right": "10px" },
            on: { click: _vm.copyContent }
          },
          [_vm._v(" Copy ")]
        )
      ])
    ]),
    _vm.data
      ? _c(
          "div",
          { staticClass: "table-block" },
          [
            _c("vue-good-table", {
              attrs: {
                columns: _vm.columns,
                rows: _vm.rows,
                "pagination-options": { enabled: false },
                "search-options": { enabled: false },
                "sort-options": {
                  enabled: true,
                  initialSortBy: { field: "question", type: "asc" }
                },
                "line-numbers": false,
                "style-class": "vgt-table musical bordered condensed"
              },
              on: { "on-row-click": _vm.rowClick },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table-row",
                    fn: function(props) {
                      return [
                        props.column.field == "delete"
                          ? _c("span", [
                              _vm.$can("delete", "faq")
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteQuestion(
                                            props.row.originalIndex
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("delete question")]
                                  )
                                : _vm._e()
                            ])
                          : _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    props.formattedRow[props.column.field]
                                  ) +
                                  " "
                              )
                            ])
                      ]
                    }
                  }
                ],
                null,
                false,
                3895854161
              )
            })
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "row button-row" }, [
      _c("div", { staticClass: "col-10" }, [
        _vm.error
          ? _c("div", { staticClass: "error-message text-right" }, [
              _vm._v(" " + _vm._s(_vm.error) + " ")
            ])
          : _vm._e(),
        _c("div", { staticClass: "loading-message text-right" }, [
          _vm._v(" " + _vm._s(_vm.loadingMsg) + " ")
        ])
      ]),
      _c("div", { staticClass: "col-2" }, [
        _c("div", { staticClass: "text-right save-btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-xs",
              on: { click: _vm.saveAnswer }
            },
            [_vm._v(" Save Q & A ")]
          )
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "row form-row", staticStyle: { "min-height": "300px" } },
      [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("quill-editor", {
              ref: "myQuillEditor1",
              staticStyle: { height: "200px !important" },
              attrs: { id: "question", options: _vm.editorOption },
              on: {
                ready: function($event) {
                  return _vm.onEditorReady($event)
                }
              },
              model: {
                value: _vm.curFaq.question,
                callback: function($$v) {
                  _vm.$set(_vm.curFaq, "question", $$v)
                },
                expression: "curFaq.question"
              }
            }),
            _c(
              "div",
              {
                class: [
                  _vm.attemptSubmit && _vm.missingQuestion
                    ? "is-not-valid"
                    : "is-valid"
                ]
              },
              [_vm._v(" Question is required. ")]
            )
          ],
          1
        ),
        _vm._m(2),
        _c(
          "div",
          { staticClass: "col-5" },
          [
            _c("quill-editor", {
              ref: "myQuillEditor2",
              staticStyle: { height: "200px !important" },
              attrs: { id: "answer", options: _vm.editorOption },
              model: {
                value: _vm.curFaq.answer,
                callback: function($$v) {
                  _vm.$set(_vm.curFaq, "answer", $$v)
                },
                expression: "curFaq.answer"
              }
            }),
            _c(
              "div",
              {
                class: [
                  _vm.attemptSubmit && _vm.missingAnswer
                    ? "is-not-valid"
                    : "is-valid"
                ]
              },
              [_vm._v(" Answer is required. ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [_c("h5", [_vm._v("FAQs")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 label" }, [
      _c(
        "label",
        { staticClass: "label required", attrs: { for: "question" } },
        [_vm._v("question")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 label" }, [
      _c("label", { staticClass: "label required", attrs: { for: "bio" } }, [
        _vm._v("Answer")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }